export const isValidCNPJ = (cnpj: string): boolean => {
  if (!cnpj) return false;
  const cleaned = cnpj.replace(/\D/g, '');

  if (cleaned.length !== 14) return false;

  if (/^(\d)\1+$/.test(cleaned)) return false;

  const digits = cleaned.split('').map(Number);

  const calcCheckDigit = (base: number[]) => {
    let factor = base.length - 7;
    let sum = 0;

    for (let i = 0; i < base.length; i++) {
      sum += base[i] * factor--;
      if (factor < 2) factor = 9;
    }

    const result = sum % 11;
    return result < 2 ? 0 : 11 - result;
  };

  const firstCheckDigit = calcCheckDigit(digits.slice(0, 12));
  if (firstCheckDigit !== digits[12]) return false;

  const secondCheckDigit = calcCheckDigit(digits.slice(0, 13));
  if (secondCheckDigit !== digits[13]) return false;

  return true;
};
